export const isUnison = (lenderName?: string): boolean => lenderName === 'Unison';
